export const locale = {
  lang: 'zh1',
  data: {
    'REQUERIMIENTOS': {
      'BOTONES':{
        'SIGUIENTE': '下一頁',
        'ANTERIOR': '上一頁',
        'FINALIZAR': '完成',
        'ACEPTAR': '我接受技術要求'
      },
      'MENSAJES': {
        'CONFREQ': '您已成功接受平台技術要求',
        'OK':'好',
      },
      'CABECERA':{
        'TITULO': 'IT 設置要求',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'PASO1':{
        'TITULO': '員工要求',
        'SUB_TITULO': '1.申請條件',
        'SUB_TITULO2': '2.瀏覽器容量要求',
        'TABLE_REQUERIMIENTOS' : {
          'TD_SISTEMAS': '操作系統',
          'TD_LABEL_RECOMENDADO': '或更高（推薦）',
          'TD_NAVEGADOR': '瀏覽器',
          'TD_LABEL_SUPERIOR': '或更高',
          'TD_LABEL_LASTVERSION': '（最新版本）',
          'TD_LABEL_LASTVERSION_MIN': '（最新版本，最低版本12.3）'
        },
        'TABLE_REQUISITOS' : {
          'TD_CERTIFICAR': '安全證書',
          'TD_COOKIES': '允許Cookie',
          'TD_CIFRADO': 'TLS加密',

          'TD_CONTENT1':	'為給予我們安全證書或授權, 請把Let\'s Encrypt Authority X3 歸類為可靠機構',
          'TD_CONTENT2':	'瀏覽器必須啟用JavaScript 1.2',
          'TD_CONTENT3':	'CulturalGo Platform服務器使用cookie，但不會從用戶或其操作系統中收集信息。因調研操作需要，請務必啟用。',
          'TD_CONTENT4':	'根據項目類型，我們的報告模塊之一僅需要TLS加密'
        },
        'PARRAFO1': {
          'SUBPARRAFO1':	'如果客戶打算使用其他操作系統，如LINUX，UNIX，ChromeOS或Mobile平台，則客戶有責任確認調研於其瀏覽器中運作暢順。',
          'SUBPARRAFO2':	'為堵塞POODLE漏洞（CVE-2014-3566）和Microsoft終止對Windows XP的支援，Great Place to Work 將不再全面支援運行Windows XP的電腦訪問我們受保護的網站。 Windows XP電腦可使用應用程式要求中的Chrome或Firefox瀏覽器版本訪問我們的網站。 其他瀏覽器或可訪問網站； 但是，我們不提供對這些瀏覽器的測試或支援。'
        },
        'ADVERT': '注意：從Cultural Go版本5.0開始，將刪除對Microsoft Internet Explorer的支持。'
      },
      'PASO2':{
        'TITULO':	'調研認證',
        'SUB_TITULO1':	'3.證書',
        'SUB_TITULO2':	'4.員工的筆記本電腦/ 台式機',
        'SUB_TITULO3':	'5.來自移動設備的調研回應',
        'SUB_TITULO4':	'1.要考慮的問題',
        'SUB_TITULO5':	'2.語言幫助',
        'PARRAFO1':	'Cultural GO使用Internet Security Research Group（ISRG）提供的Let\'s Encrypt Authority X3 SSL證書。如果未安裝證書，則會向用戶顯示一個安全警告，通知該網站的安全證書有問題。用戶可以選擇繼續訪問網站或查看更多信息。但即使允許用戶瀏覽網站，每次用戶訪問該網站時，警告消息仍會出現。',
        'PARRAFO2':{
          'LINEA1':	'為訪問線上調研，員工的台式機/筆記本電腦需要：',
          'LINEA2':	'訪問調研網站的完整權限（如果有防火牆的話, 請確保用戶有適當的權限。）',
          'LINEA3':	'如調查鏈接已使用電郵發送，用戶必須有權限訪問其公司電子郵件帳戶。'
        },
        'PARRAFO3':	'調查已在平板電腦和手機等移動設備上得到驗證。 調查元素的顯示和佈置將與屏幕設備的分辨率匹配。 這取決於要執行調查的設備的型號。',
        'PARRAFO4':	'此調研界面的設計旨在為用戶於高清移動設備的垂直屏幕上得到良好的用戶體驗。',
        'PARRAFO5':	'在一些組織中，個人設備或無法完全登入WiFi網絡，因此，若用戶決定使用個人設備並通過WiFi網絡進行連接，請先驗證是否擁有訪問調研網站的權限。',
        'PARRAFO6':	'用戶需注意，若使用手機直接連結，手機的網絡供應商或會收取額外費用。',
        'PARRAFO7':{
          'LINEA1':	'用戶將通過使用特定的URL來訪問網站, 而 鏈接沒有附帶用戶信息。',
          'LINEA2':	'必須在URL中輸入獨有的用戶代碼才能啟用調研。',
          'LINEA3':	'各自獨有的用戶代碼將通過電子郵件，SMS發送或通過人力資源部門（或同等職位）手動提供給用戶。'
        },
        'PARRAFO8':{
          'LINEA1':	'1.客戶需追蹤發送電郵邀請予員工的情況：',
          'LINEA2':	'如果電子郵件服務器是外包的，請事先聯繫電子郵件提供商以告知要求。',
          'LINEA3':	'如果電子郵件服務器在其組織中，請向IT部門尋求支援。',
          'LINEA4':	'注意：在發送調研邀請時，不會發送至免費電郵的郵箱, 即：Hotmail，Gmail，Yahoo等。',
          'LINEA5':	'2.如果客戶公司電子郵件為OUTLOOK WEBACCESS，請複製鏈接並在Web瀏覽器中打開，否則將產生錯誤。',
          'LINEA6':	'3.將進行中的調研閒置30分鐘將視為“超時”，若想繼續回答調研, 必須使用相同的用戶名和密碼重新登入。 登入後系統會把用戶帶到他們最後回應過的問題。',
          'LINEA7':	'選擇答案後，會即時儲存。在儲存完成之前，用戶將無法填答其他回應，藉以確保用戶所有已填寫的回應均已儲存。'
        },
        'PARRAFO9':{
          'LINEA1':	'我們的調研僅支持在語言選擇器中已設置的語言，並只能在調查開始前選定。',
          'LINEA2':	'如所選的語言是任何需要特殊字符的語言，用戶請先確認其瀏覽器支援該字體。',
          'LINEA3':	'一般而言，所有東亞語言或其他需要特殊字符來查看調查問卷的用戶都已安裝語言包，因此除了少數用戶外，大部分用戶都不需要這樣做。',
          'LINEA4':	'對於特定字體的要求，用戶必須在各自的電腦上安裝該字體。 而Great Place to Work 不論何時都能將此類要求傳達給客戶項目團隊。'
        },
        'PARRAFO10':	'重要提示：用戶必須確保瀏覽器沒有開啟自動翻譯功能，否則，語言選擇器可能無法正常運作。'
      },
      'PASO3':{
        'TITULO':	'互聯網連線要求',
        'SUB_TITULO1':	'1. SSL加密要求',
        'SUB_TITULO2':	'2.帶寬要求',
        'SUB_TITULO3':	'3.防火牆白名單：Web服務器IP和域訪問',
        'SUB_TITULO4':	'4.防火牆白名單：電子郵件服務器',
        'SUB_TITULO5':	'5.生成回應組（Kioskos）',
        'PARRAFO1':	'客戶端Web瀏覽器應支持啟用SSL的網站。 這使用戶可以最大程度地保護個人信息。',
        'PARRAFO2':	'帶寬要求視乎調研和報告類型以及解決方案中使用的組件而定（視頻，閃存和圖像）。 對於具有這些組件的調研，建議的連接為每個用戶1+ Mbit / s。 如使用較低的連接，可用性將受到影響。 對於不包含這些組件的調研，則只需要正常的網絡連接。',

        'PARRAFO3':{
          'LINEA1':	'以下清單應列入白名單，以便調查和報告站點可於使用Cultural Go:',
          'LINEA2':	'請必須授予以下網域和IP地址必要權限，以便允許員工訪問“Great Place to Work ®Trust Index”©調研。'
        },
        'PARRAFO31':	'重要提示：整個網域需要對用戶設為可用（必須授予對整個站點的訪問權限）',
        'PARRAFO4':{
          'LINEA1':	'郵件服務器需要授予對以下電郵地址的完全訪問權限：',
          'LINEA2':	'必須為您的郵件服務器授予以下權限，以避免來自Great Place to Work的電子郵件被分類為垃圾郵件：'
        },
        'PARRAFO5':{
          'LINEA1':	'重要：',
          'LINEA2':	'此設置是為了避免電郵被檢測為垃圾郵件',
          'LINEA3':	'郵件服務器必須能夠從同一個帳戶獲取數千封電子郵件',
          'LINEA4':	'在電子郵件供應商的安全規則中，添加要列入白名單的網域，並在可能的情況下將其添加為聯繫人電子郵件帳戶'
        },
        'PARRAFO6':	'在不少組織，通常會設置多台式機，以便用戶分組回答調研。 因此，有必要對輸出到Internet的帶寬進行測試，以確保連接設備將支援填寫問卷時的流量。',
        'PARRAFO7':	'建議在用戶分組回答之前，讓IT部門確認互聯網連接問題。',
        'TABLA1':{
          'TD_ELEMENTO':	'佩件',
          'TD_REGION1':	'墨西哥地區',
          'TD_REGION2':	'中南美地區',
          'TD_REGION3':	'亞洲地區',
          'TD_REGION4':	'歐洲地區',
          'TD_DOMINIO':	'域',
          'TD_SUBDOMINIO':	'子域',
          'TD_DIRECCION':	'IP方向',
          'TD_PUERTOS':	'連接口'
        },
        'TABLA2':{
          'TD1':	'發件人郵件帳戶：',
          'TD2':	'域'
        },
        'TABLADOMINIO':{
          'TD_ELEMENTO01':'應用',
          'TD_ELEMENTO02':'域名',
          'TD_ELEMENTO03':'網際協定',
          'TD_ELEMENTO04':'接口',
          'TD_ELEMENTO05':'子域名',
        },
        'TITLE1':'域： CulturalGo.com',
        'TITLE2':'域： gptw.global',
      },
      'PASO4':{
        'TITULO':	'服務水平',
        'SUB_TITULO1':	'1.支持',
        'SUB_TITULO2':	'2.系統可用性',
        'SUB_TITULO3':	'3.不可抗力',
        'SUB_TITULO4':	'4.同時發送',
        'SUB_TITULO5':	'5.系統維護',
        'TABLA1':{
          'TD_REGION1':	'墨西哥地區',
          'TD_REGION2':	'中南美地區',
          'TD_REGION3':	'亞洲地區',
          'TD_REGION4':	'歐洲地區'
        },
        'PARRAFO1':{
          'LINEA1':	'應用程式可用性= 99.5％',
          'LINEA2':	'為確保系統可用性，每年365天每週7天每天24小時監視該應用程序。 具有警報系統和支持程序。'
        },
        'PARRAFO2':	'不可抗力是指超出當事方合理控制範圍的事件，其中不限於上帝的行為，戰爭，罷工，政府法規，內亂或恐怖主義或地震，這些行為使其在法律上不可行，非法或不可能 一方履行職責。',
        'PARRAFO3':	'系統可用性服務級別不涵蓋由於客戶未能滿足此處列出的技術要求而導致的任何服務不足，或任何歸類為不可抗力的事件',
        'PARRAFO4':	'資料收集系統能支援10,000個用戶同時在線操作或在24小時內完成150萬次調研。報告應用程式支援500個用戶同時在線操作或在24小時內處理最多1,000個結果報告。',
        'PARRAFO5':{
          'LINEA1':	'Great Place to Work 保留將調查和報告應用程序關閉以進行定期維護的權利。預定的維護時間表將提前通知所有受影響的用戶。',
          'LINEA2':	'在上述維護期間，用戶可能無法使用應用程式。 如果Great Place to Work 需要延長維護時段，將通知相關的客戶。',
          'LINEA3':	'在緊急維護下，維護時段可能不會另外通知, 但對於受緊急維護影響的客戶，將收到特別通知。'
        },
      },
      'PASO5':{
        'TITULO':	'資料隱私政策',
        'SUB_TITULO1':	'1.政策',
        'PARRAFO1':	'發送和儲存在CulturalGo平台服務器中的信息受到符合ISO 27001規定的政策和程式的保護和保障。如果您有任何疑問，請聯繫您的Great Place to Work顧問。'
      },
      'VALIDACION':{
        'TITULO': '技術要求驗證',
        'DATOSTI':{
          'INFOEMPRESA': '公司信息',
          'NOMBREEMPRESA': '公司的名稱',
          'NOMBRE': 'IT經理姓名',
          'EMAIL': 'IT電子郵件',
          'TEL': 'IT電話號碼',
          'EXT': 'IT電話號碼分機',
          'CEL': 'IT手機號碼',
          'TOOLTIP': '顯示公司信息',
        },
        'TIMELINE':{
          'TITULO': '技術要求確認過程',
          'CARGANDO': '加載信息',
          'PROGRESO': '現在的進展：',
          'PROGRESO2': '技術要求驗證進度：',
          'STATUS': {
            'OK': '狀態：已完成',
            'NOTOK': '狀態：未完成',
            'TOOLTIP': '標記為完成',
          },
          'COMENTARIO': {
            'TITULO_1': '保存有關此步驟的評論',
            'INPUT': '輸入您的評論',
            'ENVIAR': '保存評論',
            'TITULO_2': '評論（從最舊的開始）',
            'CANNOT': '步驟完成後便無法提交評論',
          },
          'NOMBRES': {
            '1': '電子郵件已發送給TI經理',
            '2': 'TR設置-客戶致電',
            '3': 'TR設置-測試',
            '4': '問題單發送',
            '5': '問題單已完成',
          }
        },
        'MENSAJES': {
          'NADA': '您尚未輸入評論，您可能無法保存空白評論',
          'AUNNO': '您尚無法執行此操作，必須先完成技術要求驗證',
          'COMPLETAR': '您是否確認將此步驟的狀態更改為“已完成”？',
          'COMPLETAR_OK': '此步驟已成功更改為“已完成”',
          'BOTONES': {
            'SI': '是',
            'NO': '沒有',
          },
          'NOCOMPLETAR': '您可能尚未將此步驟標記為已完成，必須先完成上一步',
        }
      }
    },
    'REQUERIMIENTOSV3':{
      'MENSAJES':{
        'MENSAJE_SUCCESS_OK':'技術要求已更新',
        'MENSAJE_CONEX_OK':'連接成功',
        'ACTUALIZANDO_REQUERIMIENTOS': '更新技術要求',
        'MENSAJE_RESPUESTA_REQ':'* 需要回應',
        'WAR_ING_CORR':'輸入至少一封電子郵件',
      },
      'CABECERA':{
        'TITULO': '技術要求',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
       'BOTONES':{
              'SIGUIENTE': '下一個',
              'ANTERIOR': '以前',
              'FINALIZAR': '完',
              'ACEPTAR': '我接受技術要求'
            },
        'PASO1':{
          'TITULO':'貢獻者要求',
          'SUB_TITULO':'技術要求',
          'SUB_TITULO2':'PlataformaCulturalGo®5.0',
          'TEXTO0_PARTE_1':'本文檔旨在告知CulturalGo®平台的技術要求，以確保輕鬆有效地訪問Greate Place toWork®，Trust Index©調查系統，從而避免出現重複性技術問題。',
          'TEXTO0_PARTE_2':'必須遵守並驗證每個技術要求，以使您的組織合作者可以接收和響應調查。 否則，很可能會出現諸如阻塞和/或界面之類的複雜情況，從而導致協作者無法接收和響應調查。',
          'SUB_TITULO3':'貢獻者（最終用戶）要求',
          'SUB_TITULO4':'申請要求',

          'SUB_TITULO2_CARCA':'PlataformaCulturalGo®5.0',
          'TEXTO0_PARTE_1_CARCA':'本文檔旨在告知CulturalGo®平台的技術要求，以確保輕鬆有效地訪問Greate Place toWork®，Trust Index©調查系統，從而避免出現重複性技術問題。',
          'TEXTO0_PARTE_2_CARCA':'必須遵守並驗證每個技術要求，以使您的組織合作者可以接收和響應調查。 否則，很可能會出現諸如阻塞和/或界面之類的複雜情況，從而導致協作者無法接收和響應調查。',
          'TEXTO0_PARTE_1_INNMO':'本文檔旨在告知CulturalGo®平台的技術要求，以確保輕鬆有效地訪問Innmotion，Trust Index©調查系統，從而避免出現重複性技術問題。',

          'TABLE_REQUERIMIENTOS' : {
            'TD_SISTEMAS': '操作系統：',
            'TD_LABEL_RECOMENDADO': '或更高（推薦）。',
            'TD_NAVEGADOR': '瀏覽器: ',
            'TD_LABEL_SUPERIOR': '或更高.',
            'TD_LABEL_LASTVERSION': '（最新版本）.',
            'TD_LABEL_LASTVERSION_MIN': '（最新版本，最低版本12.3）.'
          },
          'TEXTO1_PARTE_1':'如果客戶打算使用上面列出的操作系統以外的其他操作系統，例如LINUX，UNIX，Chrome OS，移動操作系統等版本，則客戶有責任確保調查能夠在其瀏覽器軟件上正確運行。',
          'TEXTO1_PARTE_2':'由於POODLE（CVE-2014-3566）的漏洞以及Microsoft對Windows XP支持的終止，Great Place toWork®將不再支持從運行Windows XP的計算機訪問我們的安全網站。 Great Place toWork®將為使用應用程序要求中列出的Chrome或Firefox瀏覽器版本的運行Windows XP的計算機提供支持。 其他瀏覽器可能仍然可以訪問； 但是，將不會測試或支持這些瀏覽器。',
          'TEXTO1_PARTE_2_INNO':'由於POODLE（CVE-2014-3566）的漏洞以及Microsoft對Windows XP支持的終止，Innmotion將不再支持從運行Windows XP的計算機訪問我們的安全網站。 Innmotion將為使用應用程序要求中列出的Chrome或Firefox瀏覽器版本的運行Windows XP的計算機提供支持。 其他瀏覽器可能仍然可以訪問； 但是，將不會測試或支持這些瀏覽器。',
          'TEXTO2_PARTE_1':'注意：從版本5.0CuturalGo®開始，將刪除對Microsoft Internet Explorer的支持',
        },
        'PASO2':{
          'TITULO': '調查認證',
          'SUB_TITULO1': 'Web服務器IP和域訪問',
          'SUB_TITULO2': '防火牆白名單:',
          'TEXTO0_PARTE_1': '以下內容必須出現在白名單上，調查和報告站點才能在  Platform CulturalGo®上工作:',
          'TEXTO1_PARTE_1': '重要的是，必須對以下域和IP地址授予必要的權限，以使您的員工能夠訪問Great Place toWork®Trust Index©調查',
          'TEXTO1_PARTE_1_INNMO': '重要的是，必須對以下域和IP地址授予必要的權限，以使您的員工能夠訪問 Innmotion Trust Index©調查',
          'BTN_COMPRO_CONEX':'檢查連接',
          'BTN_SUCCE_CONEX':'連接已建立',
          'TOOL_BTN_COMPRO_CONEX':'在建服務',
          'MODAL_SUCCESS_CONEX':'連接成功',
          'ETI_INTRUC_DOMA_COPY':'複製並發送此鏈接，以防您需要驗證來自任何分散接入點的連接（不影響技術要求的驗證）。',
           'BTN_INTRUC_COPY_ENLA':'複製鏈接',
           'MODAL_COPY_ENLA_SUCC':'鏈接複製成功',

           'SUB_TITULO2_CARCA': '防火牆白名單:',
           'TEXTO0_PARTE_1_CARCA': '以下內容必須出現在白名單上，調查和報告站點才能在  Platform CulturalGo®上工作:',
           'TEXTO1_PARTE_1_CARCA': '重要的是，必須對以下域和IP地址授予必要的權限，以使您的員工能夠訪問Great Place toWork®Trust Index©調查',

          'TABLE_CONTEN':{
           'TH_ELEMENTO':'元件',
           'TH_REGIONM':'全球區域',
           'TH_REGIONC':'中南美地區',
           'TH_REGIONA':'亞洲地區',
           'TH_REGIONE':'歐洲地區',
           'TH_DOMINIO_PRINCIPAL':'主域',
           'TH_APLICADOR':'調查器',
           'TH_PLATAFORMA':'行政平台',
           'TH_ENVOLTURA':'網址套',
           'TH_RESULTADOS':'結果（Tableau®）',
           'TH_CULTURE':'文化審核®',
           'TH_PORTAL':'外部計數門戶',
           'TH_SUBDOMINIO':'子域名',
           'TH_DIRECCION_IP':'IP地址',
           'TH_PUERTOS':'港口',
           'TH_DOMINIO':'域',
           'TEXTO1':'• 所有調查的鏈接都將通過URL包裝器4all.gptw.global/傳遞，其中包含重定向到為每個公司分配的調查的站點最終地址。	',
           'TEXTO2':'• 出於安全原因，在調查期間，CulturalGo®的算法可以隨時更改最終調查的URL。 因此，必須始終使用4all.gptw.global/包裝器，該包裝器在整個調查中都是永久的 ',
           'TEXTO3':' 重要:',
           'TEXTO4':' 絕對不能直接訪問調查鏈接（例如，http：//newsurvey.culturalgo.com/Ax013s203ls），因為構成調查的令牌可能會隨時更改，恕不另行通知',
           'TEXTO5':' 重要:',
           'TEXTO6':' 用戶必須具有對整個域的完全和無限（無限制）訪問權限',
           'TEXTO7':' 郵件服務器',
           'TEXTO8':' 郵件服務器要求完全訪問以下電子郵件地址:',
           'TEXTO9':' 您的郵件服務器需要以下權限，以防止將Great Place toWork®電子郵件作為SPAM發送到clasiquen',
           'TEXTO9_INNMO':' 您的郵件服務器需要以下權限，以防止將Innmotion電子郵件作為SPAM發送到clasiquen',
           'TABLA_CONTENT2':{
             'TD_CUENTA_CORREO':' 發件人的電子郵件帳戶',
             'TD_DOMINIO':' 域',
             'TD_IP_ADDRE_PRIM':'主 IP 地址：',
             'TD_SECON_IP':'輔助 IP 地址：',
             'TD_SUBDOMINIO':'用於重定向鏈接的子域（它們用於監控）：',
           },
           'TEXTO10':'•	 此配置是為了防止將電子郵件地址檢測為垃圾郵件',
           'TEXTO11':'•	郵件服務器必須能夠從同一帳戶接收數千封電子郵件',
           'TEXTO12':'•	 在電子郵件提供商的安全規則中，添加白名單的域，並在可能的情況下將其添加為聯繫人電子郵件帳戶',
           'TEXTO13':'如果您需要支持，請發送消息至',
           'BTN_CONFIGURACION':'域和IP已配置',
           'BTN_ACCESO_ENCUESTA':'我進行了測試，沒有任何並發症',
           'BTN_RECIBI_CORREOS':'我在收件箱中收到了電子郵件',

          }
        },
        'PASO3':{
          'TITULO':'入學考試',
          'TIT_TES_PRU_ACC_SURV':'在本節中，您將能夠對通用調查進行可視化測試（與您的組織無關）:',
          'INS2_TES_PRU_ACC_SURV':'1。 點擊：',
           'INS1_1_TES_PRU_ACC_SURV':'複製鍵',
           'INS1_TES_PRU_ACC_SURV':'2。 訪問以下鏈接:',
           'INS3_TES_PRU_ACC_SURV':'3。 將密鑰粘貼到密碼單元中',
           'INS4_TES_PRU_ACC_SURV':'4。 點擊登錄',
          'TIT_TES_PRU_EM_PILO':'在本节中，您将可以测试邮件的接收',
           'INS1_TES_PRU_EM_PILO' :'1。輸入電子郵件',
           'INS2_TES_PRU_EM_PILO':'2。點擊“發送測試郵件”按鈕',
           'BTN_SE_EMA':'發送測試郵件',
           'CONTAC':'如有技術錯誤，請通過support@itbm.mx與我們聯繫，我們將很高興為您解決。',
           'WARN_TEST_EMAIL':'為了繼續進行此過程，我們已向您發送了一個確認鏈接，該鏈接指向您的電子郵件地址',
           'MSJ_SUCC_EMA_':'電子郵件發送成功',
           'MODAL_WARNI_BAND':'要繼續該過程，請確認已訪問調查和/或接收電子郵件',
           'MSJ_COP_CLA':'正在復制用戶密鑰',
           'MODAL_VERIFI_INFO':'驗證信息',

           'MODAL_WARNI_EMAL':'IMPORTANT: This link should not be shared with the employees of the organization, because it is a test link in order to validate that the necessary permissions have been granted at the opening of the survey.',
           'CONTAC_CARCA':'如有技術錯誤，請通過soporte_ca@gptwonline.com與我們聯繫，我們將很高興為您解決。',
           'WARN_TEST_EMAIL_CARCA':'為了繼續進行此過程，我們已向您發送了一個確認鏈接，該鏈接指向您的電子郵件地址',
        },
        'PASO4':{
          'TITULO':'驗證問卷',
          'PREGUNTAS':{
            'PREGUNTA_1':'1.-¿我可以毫無問題地進行設置嗎?',
            'PREGUNTA_1_INDI':'（如果您有任何問題，請指明）',
            'PREGUNTA_2':'2.-您的郵件服務器受到以下人員的信任：',
            'PREGUNTA_2_INDI1':'a) 您的內部IT團隊（完全控製配置）.',
            'PREGUNTA_2_INDI2':'b) 我要求您的提供者提供票證（提及提供者的名稱）',
            'PREGUNTA_3':'3.-¿您的電子郵件屬於企業帳戶（Gmail，Microsoft，Yahoo！等）?',
            'PREGUNTA_4':'4.-¿您是否註冊了域“ gptwonline.com”，還記得您收到的電子郵件來自該域，請確保它們沒有發送到垃圾郵件或垃圾郵件中?',
            'PREGUNTA_5':'5.-¿您是否有辦法獲取已接收電子郵件的列表（電子郵件日誌）?',
            'PREGUNTA_6':'6.-¿您的協作者安裝了哪些Internet瀏覽器? （請列出；瀏覽器-版本）',
            'PREGUNTA_7':'7.-¿您是否為員工授予了必要的權限才能瀏覽調查? （如果我遇到問題，請註明)',
            'PREGUNTA_8':'8.-¿對於調查的應用，您是否計劃為員工安排計算機室來回答調查?',
            'PREGUNTA_8_INDI1':'(¿如果是，請註明房間數和每間房間的設備數?)',
          },
          'BTN_VALIDAR_ENVIAR':'驗證並發送',
        },
        'PASO5':{
          'TITULO': '數據隱私政策',
          'SUB_TITULO':'數據隱私政策',
          'PARRAFO1': '在CULTURALGO®平台的服務器上發送和存儲的信息受到符合ISO 27001的政策和程序的保護和保護。如果對此有任何疑問，請聯繫您的Great Place ToWork®顧問.',
          'PARRAFO1_INNMO': '在CULTURALGO®平台的服務器上發送和存儲的信息受到符合ISO 27001的政策和程序的保護和保護。如果對此有任何疑問，請聯繫您的Innmotion顧問.',
          'PARRAFO2':'註冊商標',
          'PARRAFO3_1':'•	工作的好地方®和信任指數©',
          'PARRAFO3_2':'是美國Great Place To Work Institute的註冊商標，在本文檔中，這些標記僅用作參考.',
          'PARRAFO3_1_INNMO':'•	工作的好地方®和信任指數©',
          'PARRAFO3_2_INNMO':'是美國Innmotion Institute的註冊商標，在本文檔中，這些標記僅用作參考.',
          'PARRAFO4_1':'•	Cultural Go®, SuccessGo® ',
          // 'PARRAFO4_2':'它是InnovaciónTecnológicaB＆M S.A. de C.V.的註冊商標。 墨西哥',
          'PARRAFO4_2':'以及整個 Go!® 平台是開發者的註冊商標。',
          'PARRAFO5':'謝謝！!',
          'BTN_FINALIZAR':'完成並發送',
          'BTN_FINA_REQUE':'完成的技術要求',


        },
        'COPY_MESSAGE':'密鑰已復製到剪貼板',
        'COMPR_CONEXI':'檢查連接',
        'SUCCES_CONF_EMA':{
        'MODAL_SUCCESS':'郵件接收已通過驗證',
        'MODAL_INSTRUCCI':'請關閉標籤',
        },
        'FORMULARIO_TI': {
          'TAB': '流程結束',
          'TITULO': '審稿人詳情',
          'SUBTITULO': '要結束該過程，請在以下表格中輸入您的數據，然後單擊“完成”按鈕',
          'DONE': '該過程已經完成',
          'FINALIZAR': '最終確定技術要求',
          'NOTYET': 'IT 經理還沒有完成流程，他將能夠確認技術要求，直到 IT 經理輸入他們的數據',
          'FORM': {
            'NOMBRE': '姓名',
            'MAIL': '電子郵件',
            'FECHA': '完成日期',
            'SINENVIAR': '數據尚未發送'
          },
          'MENSAJES': {
            'NOMBRE': '您尚未在指定字段中輸入您的姓名',
            'GUARDANDO': '您輸入的信息正在保存中，請稍等',
            'GUARDADO': '數據已正確保存'
          }
        },
          'ETI_EMPRE':'公司:',
          'CONTAC':'聯繫我們：',
         'CONTAC_DES':'我們有什麼可以幫助你的嗎？',
         'SEND_EMA':'發送消息',
         'LABEL':'描述',
         'TEX_BTN_SEND':'發送',
         'MODA_SEN_EMAI':'正在發送消息...',
         'SUCC_MODA_SEN_EMAI':'消息發送成功',

    }
  }
};
